import { getBuildBetaAccess } from './app-state.js';
import { isBetaReadyBuildsOnly, isCustomerActionLive } from './feature-flags.js';

const WIP_MAIN_ACTIONS = ['build', 'presets', 'upgrade', 'ai_assistant'];

let sheetOpen: (() => void) | null = null;

function initBetaWipSheet(): void {
  const sheet = document.getElementById('portfolio-wip-sheet');
  const backdrop = document.getElementById('portfolio-wip-backdrop');
  let closeTimer: ReturnType<typeof setTimeout> | null = null;

  function close(): void {
    if (!sheet) return;
    if (closeTimer) {
      try {
        clearTimeout(closeTimer);
      } catch {
        /* ignore */
      }
      closeTimer = null;
    }
    sheet.classList.remove('sheet-open');
    sheet.classList.add('sheet-closing');
    closeTimer = setTimeout(() => {
      sheet.classList.remove('sheet-closing');
      sheet.setAttribute('aria-hidden', 'true');
      try {
        document.body.classList.remove('sheet-raise-app');
      } catch {
        /* ignore */
      }
      closeTimer = null;
    }, 320);
  }

  function open(): void {
    if (!sheet) return;
    if (closeTimer) {
      try {
        clearTimeout(closeTimer);
      } catch {
        /* ignore */
      }
      closeTimer = null;
    }
    sheet.classList.remove('sheet-closing');
    sheet.classList.add('sheet-open');
    sheet.setAttribute('aria-hidden', 'false');
    try {
      document.body.classList.add('sheet-raise-app');
    } catch {
      /* ignore */
    }
  }

  sheetOpen = open;

  if (backdrop) backdrop.addEventListener('click', close);
  const okBtn = document.getElementById('portfolio-wip-ok');
  if (okBtn) okBtn.addEventListener('click', close);

  const consultBtn = document.getElementById('beta-wip-consult');
  if (consultBtn) {
    consultBtn.addEventListener('click', () => {
      close();
      goToConsult();
    });
  }
}

export function openBetaWipSheet(): void {
  if (!sheetOpen) initBetaWipSheet();
  sheetOpen?.();
}

export function goToConsult(): void {
  void import('../features/orders/order-chat.js').then((m) => m.openConsultChat('view-main'));
}

function markServiceCardSoon(card: HTMLElement): void {
  const action = String(card.dataset.action || '').trim();
  if (!WIP_MAIN_ACTIONS.includes(action)) return;
  if (action === 'build' && getBuildBetaAccess()) return;
  if (card.querySelector('.service-soon-badge')) return;

  const title = card.querySelector('.service-title');
  if (title) {
    const badge = document.createElement('span');
    badge.className = 'service-soon-badge';
    badge.textContent = 'Скоро';
    title.appendChild(document.createTextNode(' '));
    title.appendChild(badge);
  }
  card.classList.add('service-card--soon');
}

function markPortfolioTabSoon(): void {
  const tab = document.getElementById('tab-portfolio');
  if (!tab || tab.querySelector('.tabbar-soon-hint')) return;

  const label = tab.querySelector('.tabbar-label');
  if (label) {
    const hint = document.createElement('span');
    hint.className = 'tabbar-soon-hint';
    hint.textContent = 'Скоро';
    label.appendChild(hint);
  }
  tab.classList.add('tabbar-item--soon');
}

export function applyBetaWipUi(): void {
  if (!isBetaReadyBuildsOnly()) return;

  initBetaWipSheet();

  const subtitle = document.querySelector('#view-main .app-header-subtitle');
  if (subtitle) {
    subtitle.textContent = getBuildBetaAccess()
      ? 'Сборка ПК и консультация.'
      : 'Бот в разработке. Пока доступна консультация.';
  }

  document.querySelectorAll('#view-main .service-card[data-action]').forEach((card) => {
    if (!(card instanceof HTMLElement)) return;
    markServiceCardSoon(card);
  });

  markPortfolioTabSoon();
}

export function handleCustomerActionGate(action: string): boolean {
  if (isCustomerActionLive(action)) return true;
  openBetaWipSheet();
  return false;
}
